import React, { createContext, useState } from 'react';
import { node } from 'prop-types';

export const FulfillmentContext = createContext({});

export const FulfillmentProvider = (props) => {
  const {
    children
  } = props;

  const [showCheckAvailability, setShowCheckAvailability] = useState(false);

  const contextValue = {
    setShowCheckAvailability,
    showCheckAvailability
  };

  return (
    <FulfillmentContext.Provider value={contextValue}>
      {children}
    </FulfillmentContext.Provider>
  );
};

FulfillmentProvider.propTypes = {
  children: node
};

FulfillmentProvider.defaultProps = {
  children: null
};